module.exports = __webpack_public_path__ + "img/memberIcon.f363805c.png";